import React from 'react';
import {
  FormGroup,
  Label,
  Input as ReactStrapInput,
  FormFeedback,
  FormText,
} from 'reactstrap';
import { withTranslation } from 'react-i18next';
// import './common.css';

const Input = ({
  id,
  label,
  onChange,
  value,
  helperText,
  invalid,
  error,
  t,
  ...props
}) => {
  return (
    <FormGroup className={props.containerClass} style={props.containerStyle}>
      <Label
        for={id}
        className={props.required ? 'required' : ''}
        hidden={props.labelHidden}
        style={props.labelStyle}
      >
        {typeof label === 'string' ? t(label) : label}
      </Label>
      <ReactStrapInput
        id={id}
        name="text"
        readOnly={props.readOnly}
        type={props.type}
        placeholder={t(props.placeholder)}
        onChange={onChange}
        value={value}
        className={props.inputClass}
        style={props.inputStyle}
        onFocus={props.onFocus}
        onBlur={props.onBlur}
        autoCapitalize={props.autoCapitalize}
        invalid={invalid && error ? true : false}
        autoComplete={props.autoComplete}
      />
      {props.accessory}
      {helperText && <FormText>{t(helperText)}</FormText>}
      {invalid && error && <FormFeedback>{t(error)}</FormFeedback>}
    </FormGroup>
  );
};

Input.defaultProps = {
  type: 'text',
  readOnly: false,
  value: '',
};

export default withTranslation('app')(Input);
